module.exports = __webpack_public_path__ + "assets/pptx_win.png";